import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface PowerBIEmbedConfig {
  reportId: string;
  workspaceId: string;
  datasetId: string;
  embedUrl: string;
  embedToken: string;
  tokenExpiration?: string;
  tenantDomain?: string;
  tenantName?: string;
  farmName?: string;
}

export interface RoleDatasetConfig {
  roleId: number;
  roleName: string;
  operationalFabricId?: string;
  financialFabricId?: string;
  executiveFabricId?: string;
}

export interface UserRoleInfo {
  isAdmin: boolean;
  roleName: string;
  roleId: number;
}

@Injectable({ providedIn: 'root' })
export class PowerBIEmbedService {
  private baseUrl = environment.apiUrl;

  constructor(private httpClient: HttpClient) {}

  getEmbedConfig(dashboardType: string = 'Operational'): Observable<PowerBIEmbedConfig> {
    const params = new HttpParams().set('dashboardType', dashboardType);
    return this.httpClient.get<PowerBIEmbedConfig>(`${this.baseUrl}/PowerBI/embed-config`, { params });
  }

  getRefreshSchedule(dashboardType: string = 'Operational'): Observable<any> {
    const params = new HttpParams().set('dashboardType', dashboardType);
    return this.httpClient.get(`${this.baseUrl}/PowerBI/refresh-schedule`, { params });
  }

  updateRefreshSchedule(payload: any, dashboardType: string = 'Operational'): Observable<any> {
    const params = new HttpParams().set('dashboardType', dashboardType);
    return this.httpClient.patch(`${this.baseUrl}/PowerBI/refresh-schedule`, payload, { params });
  }

  downloadFormattedExcel(dashboardType: string = 'Operational'): Observable<Blob> {
    const params = new HttpParams().set('dashboardType', dashboardType);
    return this.httpClient.post(`${this.baseUrl}/PowerBI/download-formatted-excel`, {}, { params, responseType: 'blob' });
  }

  getUserRoleInfo(): Observable<UserRoleInfo> {
    return this.httpClient.get<UserRoleInfo>(`${this.baseUrl}/PowerBI/user-role-info`);
  }

  getRolesConfig(): Observable<RoleDatasetConfig[]> {
    return this.httpClient.get<RoleDatasetConfig[]>(`${this.baseUrl}/PowerBI/roles-config`);
  }

  updateRolesConfig(payload: RoleDatasetConfig[]): Observable<any> {
    return this.httpClient.post(`${this.baseUrl}/PowerBI/roles-config`, payload);
  }
}
